import { PERMISSIONS } from "../../constants";
import list from "./ExpirationAlertList";

export default {
  list,
  name: 'alert-expiration',
  permissions: [PERMISSIONS.EXPIRATION_ALERT]
}